import './style.scss'
import React from 'react'

const WhatWeDo = () => {
  return (
    <div className="container whatwedo">
      <h2>Was wir tun</h2>
      <p>

        Als Full-Service-Agentur begleiten wir Unternehmen bei der digitalen Transformation – von der strategischen Konzeption bis zur technischen Umsetzung. Unser Team entwickelt maßgeschneiderte digitale Lösungen über das gesamte Technologiespektrum hinweg. Mit fundiertem technischem Know-how unterstützen wir Sie dabei, Prozesse effizienter zu gestalten, interne Abläufe zu automatisieren und Ihre Online-Präsenz zukunftsfähig auszubauen.
      </p>
      <p>
        Im Mittelpunkt unserer Arbeit stehen individuelle, nutzerorientierte Lösungen, die perfekt auf die Bedürfnisse und Werte unserer Kund:innen abgestimmt sind. Ob moderne Unternehmenswebsites, performante Webanwendungen oder komplexe Software-Architekturen – wir haben bereits zahlreiche internationale Projekte erfolgreich realisiert. Unsere Lösungen sind nicht nur technisch ausgereift, sondern auch langfristig wartbar und skalierbar – und werden von namhaften Unternehmen weltweit geschätzt.
      </p>
      <p>
        Wir glauben daran, dass sich Software an den Menschen und an den Betrieb anpassen muss – nicht umgekehrt. Statt auf starre Standardlösungen zu setzen, entwickeln wir individuelle Software, die sich nahtlos in bestehende Prozesse integriert. So schaffen wir die Grundlage für nachhaltige Effizienzsteigerungen, Wettbewerbsvorteile und innovative Geschäftsmodelle – basierend auf echten Anforderungen und praxisnaher Erfahrung.
      </p>
      <a href="/typo3" className="whatwedo__item">
        Web Entwicklung
      </a>
      <a href="/individual-software" className="whatwedo__item">
        Individualentwicklung
      </a>
      <a href="/chatbot" className="whatwedo__item">
        KI Chatbot
      </a>
      <a href="/leistungen" className="whatwedo__item">
        Leistungen
      </a>

    </div>
  )
}

export default WhatWeDo;
